export default {
  setInvoice (state, invoice) {
    state.invoice = invoice
  }
}
